/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import NavigationBar from './common/NavigationBar';
import HomePage from './home/HomePage';
import CheckusoutPage from './checkusout/CheckusoutPage';
// import AboutPage from './about/AboutPage';
// import NotFoundPage from './common/NotFoundPage';
import RegistrationPage from "./registration/RegistrationPage";
import AccountPage from "./account/AccountPage";
import AccountsPage from "./account/AccountsListPage";
import EditAccountPage from "./account/EditAccountPage";
import CreateVC from './CreateVizCode/CreateVC';
import HoldingPage from './common/HoldingPage';
import MaySighting from './sighting/SightingPage';
// import SightingPage from "./sighting/SightingPage";

// This is a class-based component because the current
// version of hot reloading won't hot reload a stateless
// component at the top-level.

class App extends React.Component {
  render() {
    return (
      <div>
        <NavigationBar />
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route path="/create-vizcode" component={CreateVC} />
          <Route path="/register" component={RegistrationPage} />
          <Route path="/accounts" component={AccountsPage} />
          <Route path="/account/edit/:id" component={EditAccountPage} />
          <Route path="/account/view/:id" component={AccountPage} />
          <Route exact path="/sighting/:vizcode" component={MaySighting} />
          <Route path="/checkusout" component={CheckusoutPage} />
          <Route component={HoldingPage} />
        </Switch>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.element
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js